import { entities } from "sbtech-sports-data-api-client";
import { Market, SelectionType, Selection } from "../../data";
import { SelectionParser, SelectionSortFuncs } from "../SelectionParser";
import { UIPreferences } from "..";

export class MarketParser {

    private ExtractEachWayFromSelectionNameRegex: RegExp = /E\/W \d+\/\d+ (\d+-{1})+(\d+)+/;

    private static _instance: MarketParser;

    private constructor() { }

    public static get instance(): MarketParser {
        if (!MarketParser._instance) {
            MarketParser._instance = new MarketParser();
        }
        return MarketParser._instance;
    }

    public parse(source: entities.Market, existingMarket: Market | undefined, uiPreferences: UIPreferences): Market {
        let existingSelections = (existingMarket ? existingMarket.selections : []) as Selection[];
        let marketType = (existingMarket ? existingMarket.typeId : source.marketType.id) as string;
        return new Market({
            id: source.id,
            type: this.getMarketType(marketType),
            typeId: marketType,
            selections: source.selections.map((x) => SelectionParser.instance.parse(
                x, existingSelections.find(sel => sel.id === x.id), uiPreferences))
                .filter(x => !x.isDisabled && x.odds)
                .sort(SelectionSortFuncs.Sort(this.getMarketType(marketType))),
            name: source.name,
            eachWayText: this.getEachWay(source)
        });
    }

    private getEachWay(market: entities.Market): string | undefined {
        for (let index: number = 0; index < market.selections.length; index++) {
            let currentMatch: RegExpMatchArray | null = market.selections[index]
                .name.match(this.ExtractEachWayFromSelectionNameRegex);
            if (currentMatch !== null) {
                return currentMatch[0];
            }
        }

        return undefined;
    }

    /* istanbul ignore next */
    private getMarketType(marketType: string): SelectionType {
        /* istanbul ignore next */
        if (this.isNotQA(marketType)) {
            switch (marketType[0]) {
                case "1": return SelectionType.ML;
                case "2": return SelectionType.HC;
                case "3": return SelectionType.OU;
            }
        }

        return SelectionType.QA;
    }

    /* istanbul ignore next */
    private isNotQA(marketType: string): boolean {
        return marketType === "1_0"
            || marketType === "2_0"
            || marketType === "3_0"
            || marketType === "1_39"
            || marketType === "2_39"
            || marketType === "3_39";
    }
}
